import { configureStore, Action, getDefaultMiddleware, AnyAction } from '@reduxjs/toolkit';
import { createEpicMiddleware, Epic } from 'redux-observable';
import { ThunkAction } from 'redux-thunk';
import { routerMiddleware } from 'connected-react-router';
import rootEpic, { RootEpicActions } from './rootEpic';

import createRootReducer, { _history, _RootState } from './rootReducer';

export const history = _history;

export type RootState = _RootState;

const epicMiddleware = createEpicMiddleware<RootEpicActions, RootEpicActions, RootState>();

// https://github.com/redux-observable/redux-observable/issues/706 参考以后看
const store = configureStore({
  reducer: createRootReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: [
    ...getDefaultMiddleware({
      serializableCheck: false
    }),
    epicMiddleware,
    routerMiddleware(history)
  ]
});

epicMiddleware.run(rootEpic);

// if (process.env.NODE_ENV === 'development' && module.hot) {
//   module.hot.accept('./rootReducer', () => {
//     const newRootReducer = require('./rootReducer').default
//     store.replaceReducer(newRootReducer)
//   })
// }

export type AppDispatch = typeof store.dispatch

export type AppThunk = ThunkAction<void, RootState, null, Action<string>>

export type AppEpic<Out extends AnyAction = AnyAction> = Epic<Out, Out, RootState>;

export default store;
